const WORDS = ["Bianco Carrara", "Granit Nero Assoluto", "Banakë kuzhine me porosi", "Statuario", "Banjo në mermer", "Shkallë", "Calacatta", "Dysheme"];

const Row = ({ hidden }) => (
  <div className="flex shrink-0 items-center" aria-hidden={hidden}>
    {WORDS.map((w) => (
      <span key={w} className="flex items-center font-display italic text-4xl sm:text-6xl lg:text-7xl text-[#F3EEE4] whitespace-nowrap">
        <span className="px-8 sm:px-12">{w}</span>
        <svg viewBox="0 0 20 20" className="w-4 h-4 sm:w-5 sm:h-5 shrink-0"><path d="M10 0l3 7 7 3-7 3-3 7-3-7-7-3 7-3z" fill="#C9A55C" /></svg>
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section className="relative bg-[#0B0B0C] py-14 sm:py-20 border-y border-[#C9A55C]/15 overflow-hidden" data-testid="marquee-section">
    <div className="marquee-track flex w-max">
      <Row />
      <Row hidden />
    </div>
  </section>
);
